import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TranslationService } from 'src/app/services/translation.service';
import * as moment from 'moment';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  activityOnly = true;
  constructor(
    private apiService: ApiService,
    private router: Router,
    public translations: TranslationService,
    private toastr: ToastrService
  ) {
    this.activityOnly = this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.activityOnly ? true : false;
  }
  oldPass = '';
  newPass = '';
  confirmPass = '';
  totalLoggedTime = 0;
  actvities: Array<any> = [];
  grid: Boolean = false;
  completedChallenges: Array<any> = [];
  user = this.apiService.user;
  myGroup = this.apiService.user.group;
  passSuccess: boolean = false;
  groups: Array<any> = []
  emailTaken: boolean = false;
  formCtrlSub: Subscription;
  url = this.apiService.url + '/uploads/';
  invalid: boolean = false;
  passInvalid: boolean = false;
  questions: Array<any> = [];
  activityCard: Boolean = false;
  activityData: any = {};
  profileForm = new FormGroup({
    firstname: new FormControl(this.user.firstname, Validators.required),
    lastname: new FormControl(this.user.lastname, Validators.required),
    city: new FormControl(this.user.city, Validators.required),
    country: new FormControl(this.user.country, Validators.required),
    email: new FormControl(this.user.email, [Validators.required, Validators.email]),
    age: new FormControl(this.user.age, Validators.required),
    gender: new FormControl(this.user.gender ? this.user.gender : 'male', Validators.required),
    image: new FormControl(this.user.profilePic),
  });

  notificationForm = new FormGroup({
    unfilled: new FormControl(this.user.unfilled, Validators.required),
    chlrecieved: new FormControl(this.user.chlrecieved, Validators.required),
    suggestions: new FormControl(this.user.suggestions, Validators.required),
    newsletter: new FormControl(this.user.newsletter, Validators.required),
  });

  get email() { return this.profileForm.get('email'); }

  ngOnInit() {
    this.getData();
    this.apiService.createActivityLogs(this.user._id).subscribe((res: any) => {
      this.totalLoggedTime = 0;
      res.data.forEach(ele => this.totalLoggedTime += ele.timeLogged);
      this.actvities = res.data;
    });
    this.apiService.createCompletedChallenge(this.user._id).subscribe((res: any) => {
      this.completedChallenges = res.data;
    });
    if (this.user.profiles) {
      this.questions = this.user.profiles.questions.map(data => {
        return { question: data.question, answers: [{ text: data.answers[0].text }] }
      });
    }
    this.formCtrlSub = this.profileForm.controls['email'].valueChanges
      .pipe(debounceTime(1500))
      .subscribe(newValue => {
        if (this.profileForm.controls['email'].valid) {
          this.apiService.checkMail({ email: newValue }).subscribe((res: any) => {
            if (res.data.length > 0 && res.data[0]._id !== this.user._id) {
              this.emailTaken = true;
            }
          });
        }
      });

  }

  getData() {
    this.apiService.getAllGroups().subscribe((res: any) => {
      this.groups = res.data;
    });
  }

  ngOnDestroy() {
    this.formCtrlSub.unsubscribe();
  }

  checkChanged(formgroup, gender) {
    this.profileForm.get(formgroup).setValue(gender);
  }

  triggerFile() {
    document.getElementById('imageselector').click();
  }

  imageSelected(event) {
    event.preventDefault();
    if (event.target.files.length > 0) {
      let temp = [];
      temp.push(this.user._id);
      let file = event.target.files[0];
      this.profileForm.get('image').setValue(file);
      var fr = new FileReader();
      fr.onload = this.onFileReaderLoad;
      fr.readAsDataURL(file);
    }
  }

  onFileReaderLoad(e) {
    document.getElementById('pimg').setAttribute('src', e.target.result);
  };

  checkStatus(tocheck, string) {
    if (this.profileForm.get(tocheck).value == string) {
      return true;
    }
    return false;
  }

  answerChange(e, i) {
    this.questions[i].answers = [];
    this.questions[i].answers.push({ text: e.target.value });
  }

  submit() {
    this.notificationSettings();
    let temp = [];
    this.invalid = false;
    temp.push(this.user._id);
    if (!this.profileForm.valid || this.emailTaken) {
      Object.keys(this.profileForm.controls).forEach(key => {
        this.profileForm.controls[key].markAsDirty();
      });
      this.invalid = true;
      return;
    }
    let formData = new FormData();
    formData.append('firstname', this.profileForm.get('firstname').value);
    formData.append('id', JSON.stringify(temp));
    formData.append('lastname', this.profileForm.get('lastname').value);
    formData.append('city', this.profileForm.get('city').value);
    formData.append('country', this.profileForm.get('country').value);
    formData.append('age', this.profileForm.get('age').value);
    formData.append('gender', this.profileForm.get('gender').value);
    formData.append('questions', JSON.stringify(this.questions));
    formData.append('email', this.profileForm.get('email').value);
    formData.append('pic', this.profileForm.get('image').value);

    this.apiService.updateUser(formData).subscribe((res => {
      this.apiService.getUser();
    }));

  }

  notificationSettings() {
    let temp = [];
    temp.push(this.user._id);
    let formData = new FormData();
    formData.append('unfilled', this.notificationForm.get('unfilled').value);
    formData.append('id', JSON.stringify(temp));
    formData.append('chlrecieved', this.notificationForm.get('chlrecieved').value);
    formData.append('suggestions', this.notificationForm.get('suggestions').value);
    formData.append('newsletter', this.notificationForm.get('newsletter').value);
    this.apiService.updateUser(formData).subscribe((res => {
      this.toastr.success('Profile updated successfully', 'Updated');
    }));
  }


  joinedOrNot(subscribers) {
    if (subscribers) {
      let index = subscribers.findIndex(data => data._id == this.apiService.user._id);
      if (index >= 0) {
        return true;
      }
      return false;
    }
  }

  unjoin(group_id) {
    let users = [];
    users.push(this.apiService.user._id);
    let index = this.myGroup.findIndex(data => data == group_id);
    this.myGroup.splice(index, 1);
    this.apiService.deAssignGroup({ group: this.apiService, users: users }).subscribe((res: any) => {
      this.getData();
    });
  }

  changePass() {
    this.passInvalid = false;
    this.passSuccess = false;
    if (this.oldPass && this.newPass && this.confirmPass) {
      if (this.newPass == this.confirmPass) {
        let temp = [];
        temp.push(this.user._id);
        let formData = new FormData();
        formData.append('password', this.newPass);
        formData.append('old', this.oldPass);
        formData.append('id', JSON.stringify(temp));
        this.apiService.updateUser(formData).subscribe(res => {
          this.oldPass = '';
          this.newPass = '';
          this.confirmPass = '';
          this.passSuccess = true;
          this.toastr.success('Password changed successfully', 'Changed');
          return
        }, err => {
          this.passInvalid = true;
        });
      }
      else {
        this.passInvalid = true;
      }
    } else {
      this.passInvalid = true;
    }
  }

  smallDate(date = new Date()) {
    return moment(date).format('MMM DD');
  }

  fullDateTime(timestamp) {
    return moment(timestamp).format("YYYY-MM-DD HH:mm:ss");
  }

  getLoggedHours(seconds) {
    let totalSeconds = seconds;
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let s = totalSeconds % 60;
    return hours;
  }

  openActivity(activity) {
    this.activityCard = true;
    this.activityData = activity;
  }

}
